import React from "react";

import Navbar from "./navBar";
import "./styles/resume.css";

function Resume() {
  return (
    <div>
      <Navbar />
      {/* <!-- ======= Resume Section ======= --> */}
      <section id="resume" className="resume">
        <div className="container">
          <div className="section-title">
            <h2>Resume</h2>
            <p>Check My Resume</p>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <h3 className="resume-title">Summary</h3>
              <div className="resume-item pb-0">
                <h4>Emily Timothy</h4>
                <p>
                  <em>
                  Passionate front-end developer with a desire to learn and grow in a collaborative team environment. Skilled in HTML, CSS, JavaScript and React. Excels at creating pixel-perfect designs and working with cross-browser compatibility issues.
                  </em>
                </p>
              </div>

              <h3 className="resume-title">Qualification</h3>
              <div className="resume-item">
                <h4>
                  femcode Africa
                </h4>
                <h5>March 2020 - January 2022</h5>
                <p>
                  <em>Acquire Html, CSS, JavaScript Skill. </em>
                </p>
              </div>
              <div className="resume-item">
                <h4>Innovation Growth Hub </h4>
                <h5>May 2022 - November 2022</h5>
                <p>
                  <em>Product Design</em>
                </p>
                <p>
                Trained and proficent in Graphics Design and UI/UX
                </p>
              </div>
              <div className="resume-item">
                <h4>
                  Abia state Polytechnic
                </h4>
                <h5>November 2017 - April 2022</h5>
                <p>
                  <em>College Education. </em>
                </p>
                <p>
                  Chemistry-Biochemistry.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <h3 className="resume-title">Professional Experience</h3>
              <div className="resume-item">
                <h4>Frontend Developer Intern</h4>
                <h5>2022</h5>
                <p>
                  <em>Kenga Africa Limited</em>
                </p>
                <p>
                  <ul>
                  
                    <li>
                    Used source control tools (GitHub) appropriately depending on the task at hand and participated in daily standups when applicable.
                    </li>
                    <li>Developed and implemented front-end code using HTML, CSS, JavaScript and React to meet business requirements.</li>
                    <li>
                    Created 30+ screen mock-ups using React, Tailwind CSS, and React Icons, which went successfully as the first part of POC in the client demo.
                    </li>
                    <li>
                    Published high-quality components to a shared library, increasing development speed and productivity by 30%.
                    </li>
                  </ul>
                </p>
              </div>
              <div className="resume-item">
                <h4>Frontend developer</h4>
                <h5>July 2021 - January 2022</h5>
                <p>
                  <em>Zeda Brothers</em>
                </p>
                <p>
                  <ul>
                    <li>
                    Developed and implemented front-end code using HTML, CSS, JavaScript to meet business requirements.
                    </li>
                    <li>
                    Collaborated with the team to design new features for our web application.
                    </li>
                    <li>
                    Ensured that all code is well documented, reusable, efficient, and follows best practices.
                    </li>
                    <li>Created screen mock-up using HTML,  CSS,  Boostrap, and Javascript,  which went successfully.</li>
                    
                  </ul>
                </p>
              </div>
              <div className="resume-item">
                <h4>Mentor</h4>
                <h5>January 2022 - Current</h5>
                <p>
                  <em>Technovation Girls Challenge</em>
                </p>
                <p>
                  <ul>
                    <li>
                    Mentor girls to be problem solvers, critical thinkers, and empower them to be leaders.
                    </li>
                    <li>
                    Mentor girls in building solutions using MIT App Inventor 
                    </li>
                    <li>
                    Equip them to be tech ntrepreneurs.
                    </li>
                    
                  </ul>
                </p>
              </div>
             
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Resume Section --> */}
    </div>
  );
}

export default Resume;
